import { render } from "./cbj.vue?vue&type=template&id=9e385432&scoped=true"
import script from "./cbj.vue?vue&type=script&lang=js"
export * from "./cbj.vue?vue&type=script&lang=js"

import "./cbj.vue?vue&type=style&index=0&id=9e385432&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e385432"]])

export default __exports__